'use client'

import Chart from './Chart'
import {type ButterflyChartProps} from './types'
import {useMemo} from 'react'

const ButterflyChart = ({
  leftChartProps,
  rightChartProps,
  data,
  yAxisKey,
}: ButterflyChartProps) => {
  const dataMaxValue = useMemo(() => {
    const toNum = (v: unknown) => {
      const n = typeof v === 'number' ? v : Number(v)
      return Number.isFinite(n) ? n : 0
    }
    let leftMax = 0
    let rightMax = 0
    for (const row of data) {
      leftMax = Math.max(leftMax, toNum(row?.[leftChartProps.category]))
      rightMax = Math.max(rightMax, toNum(row?.[rightChartProps.category]))
    }
    const max = Math.max(leftMax, rightMax)
    return Number.isFinite(max) ? max : 0
  }, [data, leftChartProps.category, rightChartProps.category])

  return (
    <div className="flex w-full flex-row divide-x border-y border-solid border-border-frosted">
      <Chart
        {...leftChartProps}
        data={data}
        yAxisKey={yAxisKey}
        reverseOrientation
        dataMaxValue={dataMaxValue || 100}
      />
      <Chart
        {...rightChartProps}
        data={data}
        yAxisKey={yAxisKey}
        dataMaxValue={dataMaxValue || 100}
      />
    </div>
  )
}

export default ButterflyChart
